import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const macroSensitivityAC: CriterionType[] = [
  {
    id: 'PV-10',
    label: 'Beta',
    shortLabel: 'Beta',
    group: AC_GROUPS.macroSensitivity,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'MACRO-10',
    label: 'Correlation with LIBOR',
    shortLabel: 'CorrLIBOR',
    group: AC_GROUPS.macroSensitivity,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'MACRO-20',
    label: 'Correlation with gold',
    shortLabel: 'CorrGold',
    group: AC_GROUPS.macroSensitivity,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'MACRO-30',
    label: 'Correlation with USD',
    shortLabel: 'CorrUSD',
    group: AC_GROUPS.macroSensitivity,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'MACRO-40',
    label: 'Correlation with VIX',
    shortLabel: 'CorrVIX',
    group: AC_GROUPS.macroSensitivity,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'MACRO-50',
    label: 'Correlation with CRB index',
    shortLabel: 'CorrCRB',
    group: AC_GROUPS.macroSensitivity,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'MACRO-60',
    label: 'Correlation with WTI crude',
    shortLabel: 'CorrWTI',
    group: AC_GROUPS.macroSensitivity,
    type: AC_TYPES.normal,
    withRange: true,
  },
];

export default macroSensitivityAC;
